import { DevBoxAction } from '../../models/dev-box-action';
import { createStringIdAdapter } from './common/string-id-adapter';

export const devBoxActionAdapter = createStringIdAdapter<DevBoxAction>();
